import { create } from 'zustand';

interface ScheduleSelectionState {
  /** Currently active (viewed) schedule ID */
  selectedScheduleId: string | null;
  /** Checked schedule IDs for bulk operations */
  checkedIds: Set<string>;
  /** Checked folder/group IDs for bulk operations */
  checkedGroupIds: Set<string>;
  /** Whether bulk-selection checkboxes are visible */
  showCheckboxes: boolean;
  selectSchedule: (id: string | null) => void;
  toggleChecked: (id: string) => void;
  toggleCheckedGroup: (id: string) => void;
  checkAll: (scheduleIds: string[], groupIds?: string[]) => void;
  clearChecked: () => void;
  isChecked: (id: string) => boolean;
  isGroupChecked: (id: string) => boolean;
  setShowCheckboxes: (show: boolean) => void;
}

export const useScheduleSelectionStore = create<ScheduleSelectionState>((set, get) => ({
  selectedScheduleId: null,
  checkedIds: new Set(),
  checkedGroupIds: new Set(),
  showCheckboxes: false,
  selectSchedule: (selectedScheduleId) => set({ selectedScheduleId }),
  toggleChecked: (id) =>
    set((s) => {
      const next = new Set(s.checkedIds);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return { checkedIds: next };
    }),
  toggleCheckedGroup: (id) =>
    set((s) => {
      const next = new Set(s.checkedGroupIds);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return { checkedGroupIds: next };
    }),
  checkAll: (scheduleIds, groupIds = []) =>
    set({ checkedIds: new Set(scheduleIds), checkedGroupIds: new Set(groupIds) }),
  clearChecked: () =>
    set({ checkedIds: new Set(), checkedGroupIds: new Set(), showCheckboxes: false }),
  isChecked: (id) => get().checkedIds.has(id),
  isGroupChecked: (id) => get().checkedGroupIds.has(id),
  setShowCheckboxes: (showCheckboxes) => set({ showCheckboxes }),
}));
